import { Link } from "react-router-dom";
import { ArrowUpRight, BookOpen } from "lucide-react";
import { OVERVIEW_MODULES } from "./documentationOverviewContent";
import {
  ACCENT_STYLES,
  SECTION_EYEBROW,
  SECTION_SPACING,
  SECTION_SUBTITLE,
  SECTION_TITLE,
  TRANSITION_HOVER,
} from "./overviewTokens";

export function ModulesSection() {
  return (
    <section aria-labelledby="doc-modules-title" className={SECTION_SPACING} id="modules">
      <p className={SECTION_EYEBROW}>Core modules</p>
      <h2 id="doc-modules-title" className={SECTION_TITLE}>
        What PhiloLMS can do
      </h2>
      <p className={SECTION_SUBTITLE}>
        PhiloLMS is organized into modules — each focused on one part of running a library. Open any
        module to see what it does and how to use it.
      </p>

      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {OVERVIEW_MODULES.map((mod) => {
          const Icon = mod.icon;
          const accent = ACCENT_STYLES[mod.accent];
          return (
            <article
              key={mod.id}
              className={`group flex h-full flex-col rounded-xl border border-slate-200 bg-white p-5 shadow-xs ring-1 ring-transparent ${accent.ring} ${TRANSITION_HOVER}`}
            >
              <div className="flex items-start justify-between">
                <div
                  className={`flex h-11 w-11 items-center justify-center rounded-lg ${accent.iconBg} ${accent.iconText} transition-transform duration-300 ease-out group-hover:scale-105`}
                >
                  <Icon className="h-5 w-5" />
                </div>
                <span
                  className={`rounded-full px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wide ${accent.badge}`}
                >
                  Module
                </span>
              </div>

              <h3 className="mt-4 font-heading text-lg font-semibold text-slate-900">
                {mod.title}
              </h3>
              <p className="mt-1 text-sm text-slate-600 leading-relaxed">{mod.tagline}</p>

              <ul className="mt-4 space-y-1.5 text-sm text-slate-700">
                {mod.points.map((p) => (
                  <li key={p} className="flex items-start gap-2">
                    <span
                      className={`mt-2 inline-block h-1.5 w-1.5 flex-shrink-0 rounded-full ${accent.iconText.replace("text-", "bg-")}`}
                      aria-hidden
                    />
                    <span>{p}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-5 flex items-center justify-between gap-3 border-t border-slate-100 pt-4">
                <Link
                  to={mod.primaryLink.to}
                  className="inline-flex items-center gap-1 text-sm font-semibold text-slate-900 transition-transform duration-200 ease-out hover:gap-1.5 hover:text-primary"
                >
                  {mod.primaryLink.label}
                  <ArrowUpRight className="h-4 w-4" />
                </Link>
                {mod.docLink && (
                  <Link
                    to={mod.docLink.to}
                    className="inline-flex items-center gap-1 text-xs font-semibold text-primary/80 transition-colors hover:text-primary"
                  >
                    <BookOpen className="h-3.5 w-3.5" />
                    {mod.docLink.label}
                  </Link>
                )}
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}
